import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { VideoTestimonialsPanelComponent } from "./video-testimonials-panel.component";
import { SharedModule } from "src/app/shared/shared.module";
import { VideoTestimonialsReferenceModule } from "./components/video-testimonials-reference/video-testimonials-reference.module";

@NgModule({
  declarations: [VideoTestimonialsPanelComponent],
  exports: [VideoTestimonialsPanelComponent],
  imports: [CommonModule, SharedModule, VideoTestimonialsReferenceModule],
})
export class VideoTestimonialsPanelModule {}
